import { api } from "./api";
import { ENDPOINTS } from "./endpoints";
import { operations } from "../types/openapi";
import { TRequestValues } from "./authClient/auth/api-utils";

type GetAllUsersOperation = operations["getAllUsers"];
type GetUserByIdOperation = operations["getUserById"];
type CreateNewUserOperation = operations["createNewUser"];
type PasswordResetOperation = operations["passwordReset"];
type BlockUserOperation = operations["blockUser"];
type UnblockUserOperation = operations["unblockUser"];
type UpdateUserOperation = operations["updateUser"];
type UpdateUserRolesOperation = operations["updateRoles"];

/**
 * Сменить пароль
 */
export const changePassword = (params: { currentPassword: string; newPassword: string }): Promise<any> => {
  return api.post(ENDPOINTS.changePassword(), params);
};

/**
 * Грид пользователей (доступен для OPERATOR)
 */
export const getUserList = (
  params: Record<string, TRequestValues>
): Promise<GetAllUsersOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.users(), params);
};

/**
 * Карточка пользователя (доступен для OPERATOR, CUSTOMER, LIQUIDITY_PROVIDER)
 */
export const getUserById = ({
  id,
}: GetUserByIdOperation["parameters"]["path"]): Promise<GetUserByIdOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.userById(id));
};

/**
 * Создать нового пользователя (доступен для OPERATOR)
 */
export const createUser = (
  formData: CreateNewUserOperation["requestBody"]["content"]["application/json"]
): Promise<CreateNewUserOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.users(), formData, {
    contentType: "multipart/form-data",
  });
};

/**
 * Сбросить пароль для пользователя (доступен для OPERATOR)
 */
export const passwordReset = ({
  userId,
}: PasswordResetOperation["parameters"]["path"]): Promise<PasswordResetOperation["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.passwordReset(userId));
};

/**
 * Заблокировать пользователя (доступен для OPERATOR)
 */
export const blockUser = ({
  id,
}: BlockUserOperation["parameters"]["path"]): Promise<BlockUserOperation["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.blockUser(id));
};

/**
 * Разблокировать пользователя (доступен для OPERATOR)
 */
export const unblockUser = ({
  id,
}: UnblockUserOperation["parameters"]["path"]): Promise<UnblockUserOperation["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.unblockUser(id));
};

/**
 * Обновить карточку пользователя (доступен для OPERATOR)
 */
export const editUser = (
  { id }: UpdateUserOperation["parameters"]["path"],
  formData: UpdateUserOperation["requestBody"]["content"]["application/json"]
): Promise<UpdateUserOperation["responses"]["200"]["content"]> => {
  return api.put(ENDPOINTS.updateUserById(id), formData, {
    contentType: "multipart/form-data",
  });
};

/**
 * Обновить роли пользователя (доступен для USER_ADMIN)
 */
export const editUserRoles = (
  { userId }: UpdateUserRolesOperation["parameters"]["path"],
  { companyId, roles }: UpdateUserRolesOperation["requestBody"]["content"]["application/json"]
): Promise<UpdateUserOperation["responses"]["200"]["content"]> => {
  return api.put(ENDPOINTS.updateUserRoles(userId), { companyId, roles });
};
